@if (model(); as rule) {
  <div class="violation-rule-details">
    <div class="violation-rule-details-header">
      <div class="violation-rule-details-header-title">
        <div class="violation-rule-details-header-title-text">
          @if (getPlatformIcon()) {
            <img [src]="getPlatformIcon()" alt="Platform" class="header-icon" />
          }
          {{ rule.displayName }}
          <span class="rule-id-badge">
            {{ rule.id }}
            <lucide-angular
              name="external-link"
              [size]="14"
              [strokeWidth]="2"
              class="external-link-icon"
              (click)="navigateToViolations(); $event.stopPropagation()"
            ></lucide-angular>
          </span>
        </div>
      </div>

      <!-- Meta line: Severity | Status | Count | Rule tags -->
      <div class="violation-rule-details-meta-section">
        <div class="violation-rule-details-meta-row">
          <span class="meta-label">{{ 'violationRulesPage.severity' | labelsProvider }}</span>
          <span class="meta-label">{{ 'violationRulesPage.statusTitle' | labelsProvider }}</span>
          <span class="meta-label">{{ 'violationRulesPage.count' | labelsProvider }}</span>
          <span class="meta-label">{{ 'violationRulesPage.ruleTags' | labelsProvider }}</span>
        </div>
        <div class="violation-rule-details-meta-values">
          <!-- Custom Severity Dropdown -->
          <div
            class="severity-dropdown-container"
            [matTooltip]="!canEditSPM() ? ('common.noEditPermission' | labelsProvider) : ''"
            matTooltipClass="tooltip-container"
            matTooltipPosition="below"
          >
            <div
              class="severity-dropdown-trigger"
              [class.severity-high]="model()?.severity === 'high'"
              [class.severity-medium]="model()?.severity === 'medium'"
              [class.severity-low]="model()?.severity === 'low'"
              [class.disabled]="isEditDisabled()"
              (click)="toggleSeverityDropdown()"
            >
              <app-severity-label
                [severity]="model()?.severity || 'low'"
                [smallSize]="true"
                class="severity-display"
              ></app-severity-label>
              @if (!isEditDisabled()) {
                @if (isSeverityDropdownOpen()) {
                  <lucide-angular
                    name="chevron-up"
                    [size]="14"
                    [strokeWidth]="1.5"
                    class="severity-dropdown-icon"
                  ></lucide-angular>
                } @else {
                  <lucide-angular
                    name="chevron-down"
                    [size]="14"
                    [strokeWidth]="1.5"
                    class="severity-dropdown-icon"
                  ></lucide-angular>
                }
              }
            </div>

            @if (isSeverityDropdownOpen()) {
              <div class="severity-dropdown-menu">
                @for (option of severityOptions; track option.value + option.displayLabel) {
                  <div
                    class="severity-dropdown-item"
                    [class.selected]="model()?.severity === option.value"
                    (click)="updateSeverity(option.value)"
                  >
                    <div class="radio-button" [class.checked]="model()?.severity === option.value">
                      <div class="radio-button-inner"></div>
                    </div>
                    <app-severity-label [severity]="option.value" [smallSize]="true"></app-severity-label>
                    <!--                    <span>{{ option.displayLabel }}</span>-->
                  </div>
                }
              </div>
            }
          </div>

          <!-- Custom Status Dropdown -->
          <div
            class="status-dropdown-container"
            [matTooltip]="!canEditSPM() ? ('common.noEditPermission' | labelsProvider) : ''"
            matTooltipClass="tooltip-container"
            matTooltipPosition="below"
          >
            <div class="status-dropdown-trigger" (click)="toggleStatusDropdown()">
              <div
                class="status-display"
                [class.status-active]="model()?.status === RuleStatus.on"
                [class.status-inactive]="model()?.status === RuleStatus.off"
                [class.disabled]="isEditDisabled()"
              >
                @if (model()?.status === RuleStatus.on) {
                  <img src="assets/images/status-icons/healthy.svg" alt="Active" class="status-icon" />
                }
                @if (model()?.status === RuleStatus.off) {
                  <img src="assets/images/status-icons/stop.svg" alt="Inactive" class="status-icon" />
                }
                <span class="status-text">{{ getStatusDisplay(model()?.status || RuleStatus.off) }}</span>
                @if (!isEditDisabled()) {
                  @if (isStatusDropdownOpen()) {
                    <lucide-angular
                      name="chevron-up"
                      [size]="14"
                      [strokeWidth]="1.5"
                      class="status-dropdown-icon"
                    ></lucide-angular>
                  } @else {
                    <lucide-angular
                      name="chevron-down"
                      [size]="14"
                      [strokeWidth]="1.5"
                      class="status-dropdown-icon"
                    ></lucide-angular>
                  }
                }
              </div>
            </div>

            @if (isStatusDropdownOpen()) {
              <div class="status-dropdown-menu">
                <div
                  class="status-dropdown-item"
                  [class.selected]="model()?.status === RuleStatus.on"
                  (click)="updateStatus(RuleStatus.on)"
                >
                  <div class="radio-button" [class.checked]="model()?.status === RuleStatus.on">
                    <div class="radio-button-inner"></div>
                  </div>
                  <img src="assets/images/status-icons/healthy.svg" alt="Active" class="status-icon" />
                  <span>{{ 'violationRulesPage.statuses.active' | labelsProvider }}</span>
                </div>
                <div
                  class="status-dropdown-item"
                  [class.selected]="model()?.status === RuleStatus.off"
                  (click)="updateStatus(RuleStatus.off)"
                >
                  <div class="radio-button" [class.checked]="model()?.status === RuleStatus.off">
                    <div class="radio-button-inner"></div>
                  </div>
                  <img src="assets/images/status-icons/stop.svg" alt="Inactive" class="status-icon" />
                  <span>{{ 'violationRulesPage.statuses.inActive' | labelsProvider }}</span>
                </div>
              </div>
            }
          </div>

          @if (count() !== null && count() !== undefined) {
            <div class="meta-count meta-count-link" (click)="navigateToViolations()">{{ count() }}</div>
          } @else {
            <div class="meta-count">-</div>
          }

          @if (rule.tags.length > 0) {
            <app-multiple-tags [tags]="rule.tags.join(',')"></app-multiple-tags>
          } @else {
            <div class="meta-empty">-</div>
          }
        </div>
      </div>
    </div>

    <!-- Description section -->
    <div class="violation-rule-details-description">
      {{ rule.description }}
    </div>

    <!-- Collapsible sections -->
    <div class="violation-rule-details-body">
      <!-- Why is this a risk? -->
      <div class="violation-rule-details-section">
        <app-accordion
          [accordionTitle]="'Why is this a risk?'"
          [boldTitle]="true"
          [withLabelPipe]="false"
          [expanded]="true"
        >
          <div class="section-content">
            <div class="section-text">
              {{ rule.riskReason || (rule.summary === '' ? rule.description : rule.summary) }}
            </div>

            @if (rule.tags.length > 0) {
              <div class="section-tags">
                <div class="tag-category">
                  <span class="tag-category-label">OWASP LLM</span>
                  <span class="tag-badge">Prompt injection</span>
                </div>
                <div class="tag-category">
                  <span class="tag-category-label">AI Agents Attack Matrix</span>
                  <span class="tag-badge">Delimiters And Special Character Extraction T2-9-1</span>
                </div>
              </div>
            }
          </div>
        </app-accordion>
      </div>

      <!-- How to triage? -->
      <div class="violation-rule-details-section">
        <app-accordion
          [accordionTitle]="'How to triage?'"
          [boldTitle]="true"
          [withLabelPipe]="false"
          [expanded]="false"
        >
          <div class="section-content">
            @if (triageSuggestion().length > 0) {
              <app-timeline [timelineItems]="triageSuggestion()" [withIcons]="false"></app-timeline>
            } @else {
              <div class="section-text">
                {{ getTriageText(rule.summary || rule.description) }}
              </div>
            }
          </div>
        </app-accordion>
      </div>

      <!-- How to fix? -->
      <div class="violation-rule-details-section">
        <app-accordion [accordionTitle]="'How to fix?'" [boldTitle]="true" [withLabelPipe]="false" [expanded]="false">
          <div class="section-content">
            @if (fixSuggestion().length > 0) {
              <app-timeline [timelineItems]="fixSuggestion()" [withIcons]="false" [violationMode]="true"></app-timeline>
            } @else {
              <div class="section-text">
                {{ rule.fixSuggestion || 'No fix suggestion provided.' }}
              </div>
            }
            @if (rule.fixSuggestion) {
              <div class="fix-suggestion-copy-container">
                <app-copy-button
                  [value]="getFixSuggestionCopyText()"
                  [text]="'Copy'"
                  [withCopyIcon]="true"
                  [isSecondaryFontColor]="false"
                />
              </div>
            }
          </div>
        </app-accordion>
      </div>
    </div>
  </div>
}
